var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 153,
    viewBox: "0 0 148 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.5972 56.2423L120.392 16.4099C121.345 15.2578 122.999 14.9605 124.296 15.7162C125.981 16.6948 126.313 18.9679 124.972 20.3739L89.2576 57.8527C88.1737 58.757 86.7012 57.3324 87.5972 56.2423Z",
    fill: "#6A7D5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7083 59.0483L129.854 25.1884C130.987 24.2053 132.624 24.2506 133.708 25.2919C135.114 26.6437 134.974 29.0433 133.422 30.2011L91.9686 61.0404C90.7571 61.7389 89.6429 59.9732 90.7083 59.0483Z",
    fill: "#6A7D5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3435 67.3198C75.3309 67.3198 72.6683 68.8375 71.0403 71.1591C69.4123 68.8375 66.7496 67.3198 63.737 67.3198C58.777 67.3198 54.7603 71.4216 54.7603 76.475C54.7603 81.1756 68.8341 98.0584 70.812 97.919C70.9642 97.9108 71.1163 97.9108 71.2685 97.919C73.2464 98.0584 87.3203 81.1838 87.3203 76.475C87.3203 71.4216 83.3036 67.3198 78.3435 67.3198Z",
    fill: "#C94335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2402 67.3198C19.2402 92.6674 42.4328 113.22 71.0402 113.22C99.6476 113.22 122.84 92.6674 122.84 67.3198",
    stroke: "#6A7D5F",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.76 116H62V125.18H79.76V116Z",
    stroke: "#6A7D5F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e436c9d2a8c9061245ef325e71886de6.svg";
export { ForwardRef as ReactComponent };